import moment from 'moment';
import { getApis } from '../../library/Apis';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../library/ContratoVersoes';
import {
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_EM_EDICAO,
} from '../../library/ContratoStatus';
import api from '../../services/api';
import { toRequest } from '../../utils/RequestUtils';
import { contratoAlteraStatus, loadContratoArquivos } from './ContratosActions';
import { CONTRATO_TIPO_ENTE_PRIVADO } from '../../library/ContratoTipos';

export const CADASTRO_CONTRATO_ENTE_PRIVADO_ACTION =
  'CADASTRO_CONTRATO_ENTE_PRIVADO_ACTION';
export const CADASTRO_DISTRATO_ENTE_PRIVADO_ACTION =
  'CADASTRO_DISTRATO_ENTE_PRIVADO_ACTION';
export const EDITAR_CONTRATO_ENTE_PRIVADO_ACTION =
  'EDITAR_CONTRATO_ENTE_PRIVADO_ACTION';
export const EDITAR_ADITIVO_ENTE_PRIVADO_ACTION =
  'EDITAR_ADITIVO_ENTE_PRIVADO_ACTION';
export const EDITAR_DISTRATO_ENTE_PRIVADO_ACTION =
  'EDITAR_DISTRATO_ENTE_PRIVADO_ACTION';
export const CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION =
  'CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION';
export const LOADING_LINHAS_ORCAMENTARIAS = 'LOADING_LINHAS_ORCAMENTARIAS';
export const LOADED_LINHAS_ORCAMENTARIAS = 'LOADED_LINHAS_ORCAMENTARIAS';
export const CLEARED_CONTRATO_ENTE_PRIVADO_ACTION =
  'CLEARED_CONTRATO_ENTE_PRIVADO_ACTION';
export const LOADING_CONTRATO_ACTION = 'LOADING_CONTRATO_ACTION';
export const LOADED_CONTRATO_ACTION = 'LOADED_CONTRATO_ACTION';
export const LOADING_CONTRATO_ENTE_PRIVADO_ALTERA_STATUS_ACTION =
  'LOADING_CONTRATO_ENTE_PRIVADO_ALTERA_STATUS_ACTION';
export const LOADED_CONTRATO_ENTE_PRIVADO_ALTERA_STATUS_ACTION =
  'LOADED_CONTRATO_ENTE_PRIVADO_ALTERA_STATUS_ACTION';
export const LOADING_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL =
  'LOADING_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL';
export const LOADED_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL =
  'LOADED_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL';
export const DOWNLOADING_CONTRATO_VALIDACAO_ACTION =
  'DOWNLOADING_CONTRATO_VALIDACAO_ACTION';
export const LOADING_CONTRATO_VALIDACAO = 'LOADING_CONTRATO_VALIDACAO';
export const LOADED_CONTRATO_VALIDACAO = 'LOADED_CONTRATO_VALIDACAO';

export const LOADING_CONTRATO_ENTE_PRIVADO_ARQUIVOS =
  'LOADING_CONTRATO_ENTE_PRIVADO_ARQUIVOS';
export const LOADED_CONTRATO_ENTE_PRIVADO_ARQUIVOS =
  'LOADED_CONTRATO_ENTE_PRIVADO_ARQUIVOS';

const getEndpoint = (version) => {
  return getApis().apis.contrato + 'v' + version;
};

export const changeContratoEntePrivadoEditingValue = (name, value) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      if (typeof value === 'string') {
        if (value.trim().length > 0) {
          dispatch({
            type: CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION,
            payload: { name, value },
          });
          resolve();
        } else {
          dispatch({
            type: CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION,
            payload: { name, value: '' },
          });
          resolve();
        }
      }
      dispatch({
        type: CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION,
        payload: { name, value },
      });
      resolve();
    });
  };
};

export const clearContratoEntePrivadoEditing = () => ({
  type: CLEARED_CONTRATO_ENTE_PRIVADO_ACTION,
  payload: null,
});

export const cadastroContratoEntePrivado = (
  entePrivado,
  callbackSuccess,
  callbackError
) => {
  const dados = {
    atividades: entePrivado.atividades,
    codCoop: entePrivado.codCoop,
    cpfProfessor: entePrivado.cpfProfessor,
    dataInicio: moment(entePrivado.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
    dataFim: moment(entePrivado.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
    emailCoop: entePrivado.emailCoop,
    idEscola: entePrivado.idEscola,
    nomEscola: entePrivado.nomEscola,
    planosTrabalho: entePrivado.planosTrabalho,
    totalMeses: entePrivado.totalMeses,
    escolaCompromissoCheck: entePrivado.escolaCompromissoCheck,
    flgAnaliseJuridica: entePrivado.flgAnaliseJuridica,
  };
  return (dispatch) => {
    toRequest(
      api.post,
      [`${getEndpoint(1)}/contrato/ente-privado`, dados],
      'save'
    ).then(
      (resp) => {
        switch (dados.versaoContrato) {
          case CONTRATO_VERSAO_ADITIVO:
            dispatch(
              changeContratoEntePrivadoEditingValue('idAditivo', resp.data.id)
            );
            break;
          case CONTRATO_VERSAO_DISTRATO:
            dispatch(
              changeContratoEntePrivadoEditingValue('idDistrato', resp.data.id)
            );
            break;
          default:
            dispatch(
              changeContratoEntePrivadoEditingValue('idContrato', resp.data.id)
            );
            break;
        }
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
        dispatch({
          type: CADASTRO_CONTRATO_ENTE_PRIVADO_ACTION,
          payload: resp.data,
        });
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const editarEntePrivado = (
  id,
  entePrivado,
  callbackSuccess,
  callbackError
) => {
  const dados = {
    atividades: entePrivado.atividades,
    codCoop: entePrivado.codCoop,
    cpfProfessor: entePrivado.cpfProfessor,
    dataInicio: moment(entePrivado.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
    dataFim: moment(entePrivado.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
    emailCoop: entePrivado.emailCoop,
    idEscola: entePrivado.idEscola,
    nomEscola: entePrivado.nomEscola,
    planosTrabalho: entePrivado.planosTrabalho,
    totalMeses: entePrivado.totalMeses,
    escolaCompromissoCheck: entePrivado.escolaCompromissoCheck,
  };
  return (dispatch) => {
    toRequest(
      api.put,
      [`${getEndpoint(1)}/contrato/ente-privado/${id}`, dados],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
        dispatch({
          type: EDITAR_CONTRATO_ENTE_PRIVADO_ACTION,
          payload: resp.data,
        });
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const buscarLinhasOrcamentarias = (callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_LINHAS_ORCAMENTARIAS,
      payload: true,
    });
    toRequest(
      api.get,
      [`${getEndpoint(1)}/linhaOrcamentaria`],
      'linhasOrcamentarias'
    ).then(
      (resp) => {
        dispatch({
          type: LOADING_LINHAS_ORCAMENTARIAS,
          payload: false,
        });
        dispatch({
          type: LOADED_LINHAS_ORCAMENTARIAS,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_LINHAS_ORCAMENTARIAS,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoEntePrivado = (
  idContrato,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ACTION,
      value: true,
    });
    toRequest(
      api.get,
      [
        `${getEndpoint(
          1
        )}/contrato/ente-privado/${idContrato}/${versaoContrato}`,
      ],
      'loadContratoEntePrivado'
    ).then(
      (resp) => {
        let data = resp.data;
        data.ativo = data.flgAtivo;
        delete data.flgAtivo;
        data.dataInicio =
          data.dataInicio && data.dataInicio.length > 0
            ? moment(data.dataInicio, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';
        data.dataFim =
          data.dataFim && data.dataFim.length > 0
            ? moment(data.dataFim, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';
        data.dataDistrato =
          data.dataDistrato && data.dataDistrato.length > 0
            ? moment(data.dataDistrato, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';

        dispatch({
          type: LOADING_CONTRATO_ACTION,
          payload: false,
        });
        dispatch({
          type: LOADED_CONTRATO_ACTION,
          payload: data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoEntePrivadoAlteraStatus = (
  id,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch(
      contratoAlteraStatus(
        id,
        versaoContrato,
        LOADING_CONTRATO_ENTE_PRIVADO_ALTERA_STATUS_ACTION,
        LOADED_CONTRATO_ENTE_PRIVADO_ALTERA_STATUS_ACTION,
        callbackSuccess,
        callbackError
      )
    );
  };
};

export const cadastroAditivoEntePrivado = (
  aditivoEntePrivado,
  callbackSuccess,
  callbackError
) => {
  const dados = {
    atividades: aditivoEntePrivado.atividades,
    dataInicio: moment(aditivoEntePrivado.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
    dataFim: moment(aditivoEntePrivado.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
    planosTrabalho: aditivoEntePrivado.planosTrabalho,
    idContrato: aditivoEntePrivado.idContrato,
    totalMeses: aditivoEntePrivado.totalMeses,
    escolaCompromissoCheck: aditivoEntePrivado.escolaCompromissoCheck,
    emailCoop: aditivoEntePrivado.emailCoop,
  };
  return (dispatch) => {
    toRequest(
      api.post,
      [`${getEndpoint(1)}/contrato/ente-privado/aditivo`, dados],
      'save'
    ).then(
      (resp) => {
        dispatch(
          changeContratoEntePrivadoEditingValue('idAditivo', resp.data.id)
        );
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const editarAditivoEntePrivado = (
  idAditivo,
  aditivoEntePrivado,
  callbackSuccess,
  callbackError
) => {
  const dados = {
    atividades: aditivoEntePrivado.atividades,
    dataInicio: moment(aditivoEntePrivado.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
    dataFim: moment(aditivoEntePrivado.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
    planosTrabalho: aditivoEntePrivado.planosTrabalho,
    idContrato: aditivoEntePrivado.idContrato,
    totalMeses: aditivoEntePrivado.totalMeses,
    escolaCompromissoCheck: aditivoEntePrivado.escolaCompromissoCheck,
    emailCoop: aditivoEntePrivado.emailCoop,
  };
  return (dispatch) => {
    toRequest(
      api.put,
      [`${getEndpoint(1)}/contrato/ente-privado/aditivo/${idAditivo}`, dados],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: EDITAR_ADITIVO_ENTE_PRIVADO_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const cadastroDistratoEntePrivado = (
  distratoEntePrivado,
  callbackSuccess,
  callbackError
) => {
  let dados = {
    idContrato: distratoEntePrivado.idContrato,
    dataDistrato: moment(distratoEntePrivado.dataDistrato, 'DD MM YYYY').format('YYYY-MM-DD'),
  };
  return (dispatch) => {
    toRequest(
      api.post,
      [`${getEndpoint(1)}/contrato/ente-privado/distrato`, dados],
      'save'
    ).then(
      (resp) => {
        dispatch(
          changeContratoEntePrivadoEditingValue('idDistrato', resp.data.id)
        );
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const editarDistratoEntePrivado = (
  distratoEntePrivado,
  callbackSuccess,
  callbackError
) => {
  const dados = {
    dataDistrato: moment(distratoEntePrivado.dataDistrato, 'DD MM YYYY').format('YYYY-MM-DD'),
    idDistrato: distratoEntePrivado.idDistrato,
  };
  return () => {
    toRequest(
      api.put,
      [
        `${getEndpoint(1)}/contrato/ente-privado/distrato/${distratoEntePrivado.idDistrato
        }`,
        dados,
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadHistoricoContratoEntePrivadoAnaliseOperacional = (
  idContrato,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL,
      payload: true,
    });
    toRequest(
      api.get,
      [
        `${getEndpoint(
          1
        )}/contrato/ente-privado/listar/analiseOperacional/${idContrato}/${versaoContrato}`,
      ],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ENTE_PRIVADO_HISTORICO_ANALISE_OPERACIONAL,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoEntePrivadoSendAnaliseOperacional = (
  entePrivado,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      api.post,
      [
        `${getEndpoint(1)}/contrato/ente-privado/analiseOperacional`,
        {
          htmlContrato: entePrivado.htmlContrato,
          idContrato: entePrivado.idContrato,
          justificativa: entePrivado.justificativa,
          versaoContrato: entePrivado.versaoContrato,
        },
      ],
      'save'
    ).then(
      () => {
        if (entePrivado.htmlContrato) {
          dispatch(
            changeContratoEntePrivadoEditingValue(
              'flgStatus',
              CONTRATO_STATUS_EM_EDICAO
            )
          );
        } else {
          dispatch(
            changeContratoEntePrivadoEditingValue(
              'flgStatus',
              CONTRATO_STATUS_EM_ANALISE
            )
          );
        }
        dispatch(
          loadHistoricoContratoEntePrivadoAnaliseOperacional(
            entePrivado.idContrato,
            entePrivado.versaoContrato
          )
        );
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const gerarUrlComNomeVersao = (versaoContrato) => {
  let versaoContratoNome;

  switch (versaoContrato) {
    case 2:
      versaoContratoNome = CONTRATO_VERSAO_ADITIVO_NAME;
      break;
    case 3:
      versaoContratoNome = CONTRATO_VERSAO_DISTRATO_NAME;
      break;
    case 1:
    default:
      versaoContratoNome = CONTRATO_VERSAO_CONTRATO_NAME;
      break;
  }
  return `${getEndpoint(1)}/documento/${versaoContratoNome}/nao-assinado`;
};

export const gerarContratoNaoAssinado = (
  id,
  versaoContrato,
  tipoContrato,
  callbackSuccess,
  callbackError
) => {
  return () => {
    const url = gerarUrlComNomeVersao(versaoContrato);

    toRequest(
      api.post,
      [
        url,
        {
          id,
          versaoContrato,
          tipoContratoId: tipoContrato,
        },
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const downloadContrato = (
  idDocumento,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return () => {
    toRequest(
      api.get,
      [
        `${getEndpoint(1)}/documento/pdf/${idDocumento}`,
        {
          onDownloadProgress: (event) => {
            if (typeof callbackProgress === 'function') {
              callbackProgress(event);
            }
          },
          responseType: 'arraybuffer',
          headers: {
            Accept: 'text/csv',
            'Access-Control-Allow-Headers':
              'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          },
        },
      ],
      'download-material-pedagogico'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const uploadContrato = (
  file,
  id,
  versaoContrato,
  callbackSuccess,
  callbackError,
  callbackProgress
) => {
  return () => {
    let url = `${getEndpoint(1)}/documento/`;
    switch (versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        url = url + CONTRATO_VERSAO_ADITIVO_NAME;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        url = url + CONTRATO_VERSAO_DISTRATO_NAME;
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        url = url + CONTRATO_VERSAO_CONTRATO_NAME;
        break;
    }
    url = url + '/' + id;
    let data = new FormData();
    data.append('file', file);
    toRequest(
      api.post,
      [
        url,
        data,
        {
          headers: {
            'content-type':
              'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
          },
          onUploadProgress: ({ total, loaded }) => {
            const percent = loaded / total;
            callbackProgress({ percent }, file);
          },
        },
      ],
      'save'
    ).then(
      (resp) => {
        callbackSuccess(resp, file);
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const downloadValidacaoContrato = (
  id,
  versaoContrato,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: DOWNLOADING_CONTRATO_VALIDACAO_ACTION,
      payload: true,
    });
    toRequest(
      api.get,
      [
        `${getEndpoint(
          1
        )}/documento/${versaoContrato}/${CONTRATO_TIPO_ENTE_PRIVADO}/${id}`,
        {
          onDownloadProgress: (event) => {
            if (typeof callbackProgress === 'function') {
              callbackProgress(event);
            }
          },
          responseType: 'arraybuffer',
          headers: {
            Accept: 'text/csv',
            'Access-Control-Allow-Headers':
              'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
          },
        },
      ],
      'download-material-pedagogico'
    ).then(
      (resp) => {
        dispatch({
          type: DOWNLOADING_CONTRATO_VALIDACAO_ACTION,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: DOWNLOADING_CONTRATO_VALIDACAO_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoValidacao = (
  id,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_VALIDACAO,
      payload: true,
    });
    toRequest(
      api.get,
      [`${getEndpoint(1)}/macro/contrato/ente-privado/${id}/${versaoContrato}`],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_VALIDACAO,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_CONTRATO_VALIDACAO,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_VALIDACAO,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoEntePrivadoArquivos = (
  idContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch(
      loadContratoArquivos(
        idContrato,
        LOADING_CONTRATO_ENTE_PRIVADO_ARQUIVOS,
        LOADED_CONTRATO_ENTE_PRIVADO_ARQUIVOS,
        callbackSuccess,
        callbackError
      )
    );
  };
};
